"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerLabels = exports.toBuildMode = exports.toActionRunStatus = exports.segmentErrorMessage = exports.segmentColumns = exports.operatorLabel = exports.membershipReasonLabel = exports.isoDayDaysAgo = exports.buildStatusChip = exports.buildModeOptions = exports.actionTypeOptions = exports.actionTypeLabel = exports.actionRunStatusOptions = exports.actionRunStatusChip = exports.SEGMENT_PAGE_SIZE = exports.ALL_OPTION = void 0;
var SEGMENT_PAGE_SIZE = 10;
exports.SEGMENT_PAGE_SIZE = SEGMENT_PAGE_SIZE;
var ALL_OPTION = "all";
exports.ALL_OPTION = ALL_OPTION;
var segmentColumns = [
    { name: "Name", uid: "name" },
    { name: "Members", uid: "member_count" },
    { name: "Actions", uid: "action_count" },
    { name: "LT Sync", uid: "publish" },
    { name: "Build", uid: "build_status" },
    { name: "Updated", uid: "updated_at" },
    { name: "", uid: "row_actions" },
];
exports.segmentColumns = segmentColumns;
var operatorLabels = {
    eq: "equals",
    neq: "does not equal",
    gt: "is greater than",
    gte: "is at least",
    lt: "is less than",
    lte: "is at most",
    between: "is between",
    in_last_days: "is within the last",
    not_in_last_days: "is not within the last",
    exists: "has a value",
    not_exists: "has no value",
};
var buildModeOptions = [
    {
        key: "future_only",
        label: "Future entries only",
        description: "Players who newly match join silently. Entered actions only run for players who enter later.",
    },
    {
        key: "run_actions",
        label: "Run entered actions",
        description: "Players who newly match run every entered action, as if they had just entered.",
    },
];
exports.buildModeOptions = buildModeOptions;
var buildStatusMeta = {
    idle: { label: "Up to date", color: "success" },
    building: { label: "Building", color: "warning" },
    failed: { label: "Build failed", color: "danger" },
};
var triggerLabels = {
    entered: "Entered",
    left: "Left",
};
exports.triggerLabels = triggerLabels;
var actionTypeOptions = [
    { key: "grant_challenge", label: "Grant challenge", trigger: "entered", default_once_per_player: false },
    { key: "grant_currency", label: "Grant currency", trigger: "entered", default_once_per_player: true },
    { key: "grant_item", label: "Grant item", trigger: "entered", default_once_per_player: true },
    { key: "revoke_challenge", label: "Revoke challenge", trigger: "left", default_once_per_player: false },
    { key: "revoke_item", label: "Revoke item", trigger: "left", default_once_per_player: false },
];
exports.actionTypeOptions = actionTypeOptions;
var actionRunStatusMeta = {
    pending: { label: "Pending", color: "default" },
    running: { label: "Running", color: "accent" },
    done: { label: "Done", color: "success" },
    failed: { label: "Failed", color: "danger" },
    unknown: { label: "Unknown", color: "warning" },
};
var actionRunStatusOptions = Object.keys(actionRunStatusMeta).map(function (status) { return ({
    key: status,
    label: actionRunStatusMeta[status].label,
}); });
exports.actionRunStatusOptions = actionRunStatusOptions;
var membershipReasonLabels = {
    rule: "Rules",
    override: "Manual override",
    rebuild: "Rebuild",
    sweep: "Scheduled re-check",
    migration: "Migration",
    removed: "Player removed",
};
var actionTypeLabel = function (actionType) { var _a, _b; return (_b = (_a = actionTypeOptions.find(function (option) { return option.key === actionType; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : actionType; };
exports.actionTypeLabel = actionTypeLabel;
var operatorLabel = function (operator) { var _a; return (_a = operatorLabels[operator]) !== null && _a !== void 0 ? _a : operator; };
exports.operatorLabel = operatorLabel;
var buildStatusChip = function (status) { var _a; return (_a = buildStatusMeta[status]) !== null && _a !== void 0 ? _a : { label: status || "Unknown", color: "default" }; };
exports.buildStatusChip = buildStatusChip;
var actionRunStatusChip = function (status) { var _a; return (_a = actionRunStatusMeta[status]) !== null && _a !== void 0 ? _a : { label: status, color: "default" }; };
exports.actionRunStatusChip = actionRunStatusChip;
var membershipReasonLabel = function (reason) { var _a; return (_a = membershipReasonLabels[reason]) !== null && _a !== void 0 ? _a : reason; };
exports.membershipReasonLabel = membershipReasonLabel;
var toBuildMode = function (value) { var _a; return (_a = buildModeOptions.find(function (option) { return option.key === value; })) === null || _a === void 0 ? void 0 : _a.key; };
exports.toBuildMode = toBuildMode;
var toActionRunStatus = function (value) { var _a; return (_a = actionRunStatusOptions.find(function (option) { return option.key === value; })) === null || _a === void 0 ? void 0 : _a.key; };
exports.toActionRunStatus = toActionRunStatus;
var isoDayDaysAgo = function (days) {
    var date = new Date();
    date.setDate(date.getDate() - days);
    return "".concat(date.getFullYear(), "-").concat(String(date.getMonth() + 1).padStart(2, "0"), "-").concat(String(date.getDate()).padStart(2, "0"));
};
exports.isoDayDaysAgo = isoDayDaysAgo;
// a 400 from the service carries its message in data, while a 200 with success false surfaces it as error
var segmentErrorMessage = function (error) {
    var _a;
    var failure = error;
    return ((_a = failure === null || failure === void 0 ? void 0 : failure.data) === null || _a === void 0 ? void 0 : _a.message) || (failure === null || failure === void 0 ? void 0 : failure.error) || "The request was unsuccessful.";
};
exports.segmentErrorMessage = segmentErrorMessage;
